/* SEERAT v5.4.0 — Facticied */
(function () {
  'use strict';

  // Save percentage on product cards. Percent is worked out here, not in Liquid.
  // Uses its own attribute so it never touches the product page badge.
  function apply(el) {
    var price = parseInt(el.getAttribute('data-price'), 10);
    var compare = parseInt(el.getAttribute('data-compare'), 10);
    var min = parseInt(el.getAttribute('data-min'), 10) || 1;
    if (!(compare > price && price >= 0)) return;
    var pct = Math.round(((compare - price) / compare) * 100);
    if (pct < min) return;
    var label = el.getAttribute('data-label') || 'Save [percent]%';
    el.textContent = label.replace('[percent]', pct);
    el.classList.add('is-percent');
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('[data-seerat-card-save]')) apply(root);
    Array.prototype.forEach.call(root.querySelectorAll('[data-seerat-card-save]'), apply);
  }

  function init() {
    scan(document);
    // Quick add, filters and search insert new cards later
    if ('MutationObserver' in window) {
      new MutationObserver(function (list) {
        list.forEach(function (m) {
          Array.prototype.forEach.call(m.addedNodes, function (n) {
            if (n.nodeType === 1) scan(n);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  window.SeeratCardSave = { scan: scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
